import { Box, Button, FormControl, FormLabel, Input, useDisclosure } from "@chakra-ui/react";
import useLang from "hooks/useLang";
import React, { useState } from "react";
import Select from "react-select";
import useGetAll from "hooks/useGetAll";
import { useSelector } from "react-redux";
import { getTrainerClients } from "services/clients";
import LoadingResponseNutrition from "./LoadingResponse";
import TypingEffect from "./TypingEffect";

const CustomNutrition = () => {
  const { t } = useLang();
  const { id_user } = useSelector(({ user }) => user);

  const { data: dataNameClient } = useGetAll("clients", id_user, getTrainerClients);
  const [client, setClient] = useState("");
  const [clientName, setClientName] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loader, setloader] = useState(false);
  const [response, setResponse] = useState("");

  const options = dataNameClient?.map(({ name, lastName, _id }) => {
    const returnOptions = {
      value: _id,
      label: `${name} ${lastName || ""}`,
    };
    return returnOptions;
  });

  const chooseClient = (e) => {
    setClient(e.value);
    setClientName(e.label);
  };

  return (
    <Box display="flex" flexWrap="wrap">
      <Box
        w={{ base: "100%", md: "50%" }}
        p={5}
        display="flex"
        flexDirection="column"
        style={{ gap: "1rem" }}>
        <h3 style={{ fontSize: "34px", lineHeight: "2rem" }}>
          {t("nutrition_section.header")}{" "}
          <span style={{ color: "#b42519", fontWeight: "bold" }}>Perfect Trainer</span> {t("using")}{" "}
          <span style={{ color: "#b42519", fontWeight: "bold" }}>IA</span>
        </h3>
        <Box>
          <Box>
            <span>{t("nutrition_section.assign_nutrition")}</span>
            <Select placeholder={t("select_a_client")} options={options} onChange={chooseClient} />
          </Box>
          <FormControl>
            <FormLabel>
              Diet Styles
            </FormLabel>
            <Input
              placeholder="write diet styles"
              name="diet"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Age
            </FormLabel>
            <Input
              placeholder="years old"
              name="age"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Gender
            </FormLabel>
            <Input
              placeholder="ej, female"
              name="gender"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Body fat
            </FormLabel>
            <Input
              placeholder="body fat percentage"
              name="body_fat"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Body Weight
            </FormLabel>
            <Input
              placeholder="weight"
              name="body_weight"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Body height
            </FormLabel>
            <Input
              placeholder="height"
              name="body_height"
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              Activity Level
            </FormLabel>
            <Input
              placeholder="activity"
              name="activity_level"
            />
          </FormControl>
          macronutrientes
          <FormControl>
            <FormLabel>
              Activity Level
            </FormLabel>
            <Input
              placeholder="activity"
              name="activity_level"
            />
          </FormControl>
          Macronutients
        </Box>
      </Box>
      <Box
        w={{ base: "100%", md: "50%" }}
        p={5}
        display="flex"
        flexDirection="column"
        style={{ gap: "1rem" }}>
        <Box
          display="flex"
          flexDirection="column"
          w={{ base: "100%", md: "50%" }}
          bg="white"
          h="100vh"
          justifyContent="space-between"
          borderRadius="15px"
          p={5}>
          <Box display="flex" overflowY="scroll">
            {loader ? (
              <LoadingResponseNutrition />
            ) : (
              <>
                <TypingEffect speed={10} text={response} />
              </>
            )}
          </Box>
          {response && (
            <Box display="flex" justifyContent="space-between" my={2}>
              <Button onClick={console.log("a")}>{t("nutrition_section.generate_another")}</Button>
              <Button
                variant="solid"
                bg="#b42519"
                border="1px solid #b42519"
                _hover={{
                  bg: "white",
                  border: "1px solid #b42519",
                  color: "#b42519",
                }}
                onClick={onOpen}
                color="white">
                {t("save")}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomNutrition;
